import i18n from "../../../config/dictionary/i18n";
import dayjs from "dayjs";

export const asStartOfDay = (date: Date | undefined | null): Date | undefined => {
    if (date === undefined || date === null) {
        return undefined;
    }
    return dayjs(date).startOf('day').toDate()
}

export const asEndOfDay = (date: Date | undefined | null): Date | undefined => {
    if (date === undefined || date === null) {
        return undefined;
    }
    return dayjs(date).endOf('day').toDate()
}

export const getPastYears = (years: number, from: number = dayjs().year()): number[] => {
    let start = from - years;
    return Array.from(Array(from - start + 1).keys()).map(x => x + start);
}

export const getLiteralMonth = (month: number): string => {
    return new Date(Date.UTC(0, month || 0, 1)).toLocaleDateString('en', { month: 'long' }).toUpperCase()
}

export const getLiteralMonths = (): string[] => {
    let months = [];
    for (let i = 0; i < 12; i++) {
        months.push(new Date(Date.UTC(0, i, 1)).toLocaleDateString(i18n.language, { month: 'long' }));
    }
    return months;
}